import React, {Component} from 'react';

class List extends Component {

    render() {
        if (!(this.props.format.field in this.props.entry.fields)) {
            return null;
        }

        let counter = 0;
        return (
            <p>
                <span><i className={this.props.format.icon}/> {this.props.format.label} :</span>
                {this.props.entry.fields[this.props.format.field].map((entry) => {
                    return (
                        <b key={counter++}>
                            {"subField" in this.props.format ? entry.fields[this.props.format.subField] : entry}
                        </b>
                    );
                })}
            </p>
        );
    }
}

export default List;


// WEBPACK FOOTER //
// ./src/Components/MaintenantCards/List.js